import { takeEvery, takeLatest } from 'redux-saga/effects';
import { StrapiActionTypes } from '../types/strapiMyTasks';
import { MainTable5SActionTypes } from '../types/mainTable5S';
import { Inconsistency5SFilesActionTypes } from '../types/inconsistency5SFiles';
import { Report5SAuditsActionTypes } from '../types/report5SAudits';
import { ReportDone5SAuditActionTypes } from '../types/reportDone5SAudit';
import { fetchDataSagaMyTasks } from '../store/filtersData/saga';
import { addData5SCardSaga, updateData5SCardSaga, deleteData5SCardSaga, refreshCardsAfterSuccess } from '../store/formAdd5SCard/saga';
import { loadMainTableSaga, loadEditCardSaga, refreshMainTableSaga, deleteCardSaga } from '../store/mainTable5S/saga';
import {
  fetchInconsistencyFilesSaga,
  uploadInconsistencyFileSaga,
  deleteInconsistencyFileSaga,
} from '../store/inconsistency5SFiles/saga';
import { loadReport5SChartSaga } from '../store/report5SAudits/saga';
import { loadReportDoneSaga } from '../store/reportDone5SAudit/saga';

export function* myTasksWatcherStrapi() {
  yield takeEvery(StrapiActionTypes.FETCH_REQUEST_MYTASKS, fetchDataSagaMyTasks);
  yield takeEvery(StrapiActionTypes.ADD_REQUEST_MYTASKS, addData5SCardSaga);
  yield takeEvery(StrapiActionTypes.UPDATE_REQUEST_MYTASKS, updateData5SCardSaga);
  yield takeEvery(StrapiActionTypes.DELETE_REQUEST_MYTASKS, deleteData5SCardSaga);
  yield takeEvery(StrapiActionTypes.ADD_SUCCESS_MYTASKS, refreshCardsAfterSuccess);
  yield takeEvery(StrapiActionTypes.UPDATE_SUCCESS_MYTASKS, refreshCardsAfterSuccess);

  yield takeLatest(MainTable5SActionTypes.LOAD_TABLE_REQUEST, loadMainTableSaga);
  yield takeEvery(MainTable5SActionTypes.LOAD_EDIT_CARD_REQUEST, loadEditCardSaga);
  yield takeLatest(MainTable5SActionTypes.DELETE_CARD_REQUEST, deleteCardSaga);
  yield takeEvery(StrapiActionTypes.ADD_SUCCESS_MYTASKS, refreshMainTableSaga);
  yield takeEvery(StrapiActionTypes.UPDATE_SUCCESS_MYTASKS, refreshMainTableSaga);

  yield takeEvery(Inconsistency5SFilesActionTypes.FETCH_REQUEST, fetchInconsistencyFilesSaga);
  yield takeEvery(Inconsistency5SFilesActionTypes.UPLOAD_REQUEST, uploadInconsistencyFileSaga);
  yield takeEvery(Inconsistency5SFilesActionTypes.DELETE_REQUEST, deleteInconsistencyFileSaga);

  yield takeLatest(Report5SAuditsActionTypes.LOAD_CHART_REQUEST, loadReport5SChartSaga);
  yield takeLatest(ReportDone5SAuditActionTypes.LOAD_REQUEST, loadReportDoneSaga);
}
